exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.md-table[data-v-9b156a14] {\n  width: 100%;\n}\n", ""]);

